import { Loader } from '@creditsights/styleguide-web';
import { ReactElement } from 'react';
import useFetchProfile from '../../hooks/user/useFetchProfile';
import './UpgradeSubscription.scss';

const LINK = 'https://know.creditsights.com/upgrade-your-plan/';

export const HEADER_TEXT = 'Upgrade your Subscription to Access this Content';
const DEFAULT_SUBSCRIPTIONS_EMAIL_ADDRESS = 'subscriptions@creditsights.com';

interface UpgradeSubscriptionProps {
  showHeader: boolean;
}

function UpgradeSubscription({ showHeader }: UpgradeSubscriptionProps): ReactElement {
  const { data: profile, isLoading } = useFetchProfile();
  const renderClientServicesLink = () => {
    return (
      <a href={LINK} target="_blank" rel="noreferrer">
        Client Services
      </a>
    );
  };

  const renderSalesLink = () => {
    const email = profile?.assignedAccountManager ? profile.assignedAccountManager.email : DEFAULT_SUBSCRIPTIONS_EMAIL_ADDRESS;
    return (
      <span>
        account representative at <a href={`mailto:${email}`}>{email}</a>
      </span>
    );
  };

  return (
    <div className="upgrade-subscription-ctx">
      {isLoading && <Loader position="center" />}
      {!isLoading && (
        <>
          {showHeader && <h3>{HEADER_TEXT}</h3>}
          <p>
            Avoid missing our indispensable insights by upgrading your account. To learn more, contact your {renderSalesLink()} or {renderClientServicesLink()}.
          </p>
        </>
      )}
    </div>
  );
}

export default UpgradeSubscription;
